import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { requestSearchProduct } from 'requests/products'
import { SelectAutocomplete } from 'ui-components/SelectAutocomplete'
import { ProductOption, ProductCode, ProductQuantity } from './styles'

export default function SearchProductInput({ onSelect }) {
  const [searching, setSearching] = useState(false)
  const [selectOptions, setSelectOptions] = useState([])
  const [selected, setSelected] = useState()
  const [products, setProducts] = useState([])

  let searchTimer = null

  const handleProductSelect = (option) => {
    setSelected(option)

    const product = products.find((item) => item.id === option.id)
    onSelect(product)
  }

  const searchProduct = async (value) => {
    setSearching(true)
    const { data } = await requestSearchProduct(value)

    setSearching(false)
    if (!data?.length) return setProducts([])

    const options = data.map((product) => ({
      id: product.id,
      code: product.attributes.code,
      name: product.attributes.name,
      quantity: product.attributes.product_stock_attributes?.quantity,
    }))

    setProducts(data)
    return setSelectOptions(options)
  }

  const handleAutocomplete = (evt) => {
    const { value } = evt.target
    if (!value) {
      setSelectOptions([])
      return
    }

    if (value.length < 2) return

    clearTimeout(searchTimer)
    searchTimer = setTimeout(() => {
      searchProduct(value)
    }, 600)
  }

  const renderOption = (option) => (
    <ProductOption>
      <ProductCode>
        {`Cod: ${option.code}`}
      </ProductCode>
      <div>
        { option.name }
      </div>
      <ProductQuantity>
        {`Qtd: ${option.quantity}`}
      </ProductQuantity>
    </ProductOption>
  )

  return (
    <SelectAutocomplete
      label="Produto"
      name="product"
      options={selectOptions}
      onChange={handleAutocomplete}
      loading={searching}
      onSelect={handleProductSelect}
      noOptionsText={products.length ? 'Registro não encontrado' : 'Insira o código'}
      selected={selected || null}
      renderOption={renderOption}
    />
  )
}

SearchProductInput.propTypes = {
  onSelect: PropTypes.func.isRequired,
}
